const { SM4 } = require('gm-crypto');
// 出码时自动生成
const pwdKey = "0123456789abcdeffedcba9876543210";
let sm4Config = {
  inputEncoding: 'utf8',
  outputEncoding: 'base64'
};


/* 
 * 加密工具函数
 * @param {String} text 待加密文本
 */
export function encrypt(text) {
  return SM4.encrypt(text, pwdKey, sm4Config);
}

/*
 * 解密工具函数
 * @param {String} text 待解密密文
 */
export function decrypt(text) {
  return sm4Util.decrypt(text, pwdKey, sm4Config);
}
